import React from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'presentation/hooks/use-stores'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import CancelledSchedulledDataGrid from 'presentation/hospital/components/Tables/CancelledScheduleDataGrid'
import * as S from './styles'

const HospitalCancelledScheduleSurgeryRequestsLayout = observer(() => {
  const currentHospital = useStores().currentHospital.actualHospital

  return (
    <S.Wrapper>
      <HeadingNew size="xlarge" color="primary600" lineHeight="large">
        Cancelamento de agendamentos
        {/* {currentHospital?.friendly_name} */}
      </HeadingNew>
      <CancelledSchedulledDataGrid
        currentHospitalId={currentHospital!.hospital_id}
      />
    </S.Wrapper>
  )
})

export default HospitalCancelledScheduleSurgeryRequestsLayout
